import React, { useState } from "react";
import { Box, Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";
import { ICustomTabWindow } from "../interfaces/ICustomTabWindow";

interface ITabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

interface IPanelTabProps {
	tabs: ICustomTabWindow[];
}

const containerStyle: React.CSSProperties = {
	display: "flex",
	flexDirection: "column",
	height: "100%",
};
const contentContainerStyle: React.CSSProperties = {
	flexGrow: 1,
	overflow: "hidden",
	display: "flex",
	flexDirection: "column",
};

export const PanelTab: React.FC<IPanelTabProps> = (props) => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);
	const TabPanel = (props: ITabPanelProps) => {
		const { children, value, index, ...other } = props;

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				style={{ height: "100%", maxHeight: "100%" }}
				{...other}
			>
				{value === index && <Box sx={{ p: 3, height: "100%" }}>{children}</Box>}
			</div>
		);
	};

	return (
		<>
			<div style={containerStyle}>
				<div>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs
							value={selectedTabIndex}
							onChange={(event, value) => setSelectedTabIndex(value)}
							aria-label="basic tabs example"
						>
							{props.tabs.map((tab, index) => (
								<Tab
									icon={tab.icon}
									label={tab.title}
									key={`panel_tab-${index}`}
								/>
							))}
						</Tabs>
					</Box>
				</div>
				<div style={contentContainerStyle}>
					{props.tabs.map((tab, index) => (
						<TabPanel
							value={selectedTabIndex}
							index={index}
							key={`job_definitions-job_definition-content-${tab.title}-${index}`}
						>
							{tab.window}
						</TabPanel>
					))}
				</div>
			</div>
		</>
	);
};
